<template>
  <div class="device-main">
    <div class="warp">
      <my-header></my-header>
    </div>
    <div class="container">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
    <my-tool-box></my-tool-box>
  </div>
</template>
<script>
import MyHeader from '@/components/HeaderMenu'
import MyToolBox from '@/components/ToolBox'
import BScroll from 'better-scroll'
import basic from '@/model/zone'
import { mapState } from 'vuex'

export default {
  name: 'Device',
  data () {
    return {}
  },
  computed: {
    ...mapState(['zone'])
  },
  created () {
    // 请求数据，如果不存在的话
    if (!this.zone) {
      basic.getBasicInfo()
    }
  },
  components: {
    MyHeader,
    MyToolBox
  },
  mounted () {
    this.$nextTick(() => {
      if (!this.scroll) {
        this.scroll = new BScroll('.warp', {
          scrollX: true,
          click: false,
          eventPassthrough: 'vertical'
        })
      }
    })
  },
  methods: {}
}
</script>
<style scoped lang="less">
@import "../../assets/less/base";

.device-main {
  height: 100%;
  display: flex;
  flex-direction: column;
  > .container {
    flex: 1;
    padding: 92px 20px 68px 20px;
    display: flex;
    height: 100%;
  }
  > .warp {
    overflow: hidden;
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 2;
    background-color: white;
    min-height: 70px;;
    .header {
      position: absolute;
      white-space: nowrap;
    }
  }
  .all-scroll {

  }
}
</style>
